<template>
  <v-container ref="fid-spot-overlay">
    <v-tooltip top :color="spotFill" content-class="caption">
      <template v-slot:activator="{ on }">
        <canvas ref="fid-spot-canvas" v-on="on" @mousemove="movedSpot" @click="clickedSpot"></canvas>
      </template>
      <span v-if="isThumbnail">
        <v-img :src="spotImg" cover></v-img>
        <span>{{ spotTime }}</span>
      </span>
      <span v-else>{{ spotText }}</span>

    </v-tooltip>

  </v-container>
</template>
<script>
import { clearCanvas, makeCanvas } from '@/js/canvas'
import { mapState, mapMutations } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import { Spots } from '@/gql'
import { segPlot, normalizeSegments, getSpotAtEvt } from '@/js/spots'

export default {
  props: {
    labelNav: String,
    floatRate: Number,
    duration: Number,
    filmMasterID: String,
  },

  // when this changes show/clear the navigation spots
  // this means it can show even when the film isnt playing
  watch: {

    normalSpots() {
      this.spotTracking(this.currentTime)
    },
    currentTime() {
      this.spotTracking(this.currentTime)
    },
  },

  methods: {
    spotTracking(atTime) {
      // clear up anything hanging around from before
      if (this.spotCtx) clearCanvas(this.spotCtx)

      // no film/ labels set yet
      if (!this.normalSpots) {
        this.spotCtx = null
        return null
      }

      // now draw them all, after dom settles down
      this.$nextTick(() => {
        // in case this isnt made yet
        this.setSpotCanvas()
        const progress = (this.ended ? this.normalSpots.duration : atTime) / this.normalSpots.duration
        // plot the whole thing again
        segPlot({
          ctx: this.spotCtx,
          spots: this.normalSpots.spots,
          progress
        })
      })
    },

    // find which spot is being hovered over or clicked
    findSpot(evt) {
      return (
        this.normalSpots &&
        getSpotAtEvt({
          ctx: this.spotCtx,
          evt,
          spots: this.normalSpots.spots,
        })
      )
    },

    // prepare tooltip
    movedSpot(evt) {
      this.activeSpot = this.findSpot(evt)
    },

    // go to clicked spot in the film
    clickedSpot(evt) {
      const clicked = this.findSpot(evt)
      if (clicked && clicked.item) this.setPlaySegment(clicked.item)
    },



    // set up canvas for displaying spotmap
    setSpotCanvas() {

      // toolbar height
      const forceHeight = 56
      const posterElem = document.querySelector('.plyr__poster')
      const forceWidth = posterElem && posterElem.offsetWidth

      const d = makeCanvas({
        ref: this.$refs['fid-spot-canvas'],
        container: document.querySelector('.plyr__poster'),
        // constrain the height and width to match the player poster
        forceHeight,
        forceWidth
      })
      if (!this.spotCtx) {
        this.spotCtx = d.getContext('2d')
      }
    },

    ...mapMutations(vxMaps.mutations),
  },

  data: () => ({
    spotCtx: null,
    Spots: null,
    activeSpot: null,
    spotting: false,
  }),

  computed: {
    currentTime() {
      return this.playerStats.currentTime
    },
    ended() {
      return this.playerStats.ended
    },
    activeItem() {
      return this.activeSpot && this.activeSpot.item
    },
    spotFill() {
      return this.activeItem && this.activeItem.fill
    },

    spotTime() {
      const t = this.activeItem
      return t
        ? `(${t.startTime} -${t.endTime})`
        : ''
    },
    spotImg() {
      const t = this.activeItem && this.activeItem.description
      return t
        ? "data:image/png;base64," + t
        : null
    },
    spotText() {
      const t = this.activeItem && this.activeItem.text
      return t
        ? `${t} ${this.spotTime}`
        : null
    },
    isThumbnail () {
      return  this.activeItem && this.activeItem.type === 'face-label'
    },
    normalSpots() {
      return (
        this.Spots &&
        this.duration &&
        normalizeSegments({
          duration: this.duration,
          segments: this.Spots,
          fps: this.floatRate,
        })
      )
    },

    bigEnough() {
      return this.$vuetify.breakpoint.smAndUp
    },

    ...mapState(vxMaps.state),
  },
  apollo: {
    Spots: {
      skip() {
        return !this.filmMasterID
      },
      query: Spots,
      variables() {
        return {
          limit: 2000,
          filters: [
            {
              valueKey: 'filmMasterID',
              value: this.filmMasterID,
            },
            {
              valueKey: 'type',
              value: this.labelNav,
            },
          ],
        }
      },
    },
  },
}
</script>
